module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-update-driver-reservation-requests"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('ModalReveal', {
    ref: _vm.modal
  }, [_c('a', {
    attrs: {
      "slot": "trigger"
    },
    on: {
      "click": _vm.search
    },
    slot: "trigger"
  }, [_vm._v("Update status")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('Driver', {
    attrs: {
      "item": _vm.item.driver,
      "type": "driver-card"
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Dates")]), _c('div', [_vm._v("From: " + _vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMM YYYY HH:mm')) + " - " + _vm._s(_vm.item.pick_up.name))]), _c('div', [_vm._v("To: " + _vm._s(_vm.$dateFormat(_vm.item.end, 'DD MMM YYYY HH:mm')) + "  - " + _vm._s(_vm.item.drop_off.name))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Passengers")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.flags.passengers))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Offroad")]), _c('span', {
    staticClass: "fa",
    class: {
      "offroad": _vm.item.flags.offroad, "fa-times": !_vm.item.flags.offroad, "fa-check": _vm.item.flags.offroad
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Notes")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.notes))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Select status")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.status),
      expression: "body.status"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("NEW")]), _c('option', [_vm._v("WAITING")]), _c('option', [_vm._v("ACCEPTED")]), _c('option', [_vm._v("REJECTED")])]), _c('ActionButton', {
    attrs: {
      "action": _vm.updateStatus
    }
  }, [_vm._v("Update")])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15a81f42!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/UpdateDriverReservationRequestStatus.vue
// module id = 2289
// module chunks = 1